import React from 'react';
import CountUp from 'react-countup';

function WeAreKarot() {
    return (
        <div className="container-fluid green darken-1">
            <div className="pg2-content__line">
            </div>
            <div className="row pt-6">
                <div className="col-sm-12">
                    <h5 className="center bold ff-mono bold">HELLO THERE!</h5>
                </div>
                <div className="col-sm-12">
                    <div className="white-text center bold"><span style={{borderBottom: '1px solid white', fontSize: '5rem'}}>WE ARE KAROT</span></div>
                </div>
                <div className="col-sm-12 col-md-10 offset-md-1 pt-5">
                    <span className="center " style={{fontSize: '1.5rem', fontFamily: 'unset'}}>
                    We are providing the best solutions in AI, Ecommerce, Website development & designing out of Lahore (Pakistan). We have innovative, creative and technical minds.

                    Our team consists of software engineers, developers, UX architects, and designers capable of producing impactful software. We create software that is used by millions of users, in sectors spanning Education, Technology, Healthcare, Travel and beyond. We thrive on creativity and collaboration. To ensure collaboration, we encourage our teams to enjoy their social lives and facilitate it.
                    “Success is not final; failure is not fatal: it is the courage to continue that counts.” – Winston Churchill. Customer's satisfaction and happiness is our main goal to achive. We make clients our wealth and make employee our assets.
                    </span>
                </div>

                <div className="container pb-4 mb-4">
                <div className="row pt-5 pb-4 mb-4">
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <CountUp start={0} end={100} delay={0}>
                            {({ countUpRef }) => (
                                <div className="center">
                                    <span className="white-text bold " style={{fontSize: '4rem'}} ref={countUpRef} />
                                    <h5 className="ff-mono bold">Customers</h5>
                                </div>
                            )}
                        </CountUp>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <CountUp start={0} end={100} delay={0}>
                            {({ countUpRef }) => (
                                <div className="center">
                                    <span className="white-text bold" style={{fontSize: '4rem'}} ref={countUpRef} />
                                    <h5 className="ff-mono bold">Cup of Coffee</h5>
                                </div>
                            )}
                        </CountUp>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <CountUp start={0} end={100} delay={0}>
                            {({ countUpRef }) => (
                                <div className="center">
                                    <span className="white-text bold" style={{fontSize: '4rem'}} ref={countUpRef} />
                                    <h5 className="ff-mono bold">Happy Clients</h5>
                                </div>
                            )}
                        </CountUp>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <CountUp start={0} end={100} delay={0}>
                            {({ countUpRef }) => (
                                <div className="center">
                                    <span className="white-text bold" style={{fontSize: '4rem'}} ref={countUpRef} />
                                    <h5 className="ff-mono bold">Projects Completed</h5>
                                </div>
                            )}
                        </CountUp>
                    </div>
                </div>
                </div>
            </div>
            
        </div>
    )
}

export default WeAreKarot;
